/**
 * The customer's country (country_origin): Sverige / Norge / Nederländerna, set by
 * admins and sellers on Swedish-portal customers. `country` stays the portal the
 * customer is handled in. Only Nederländerna changes anything: Dutch customers are
 * handled in the Swedish portal for now - English mails and SMS, agreement numbers
 * starting with NL, and the "Nederländska kunder/avtal" filters.
 * See securecloud-server utils/country-origin.js.
 */
import { isSwedishSite } from "@/utils/siteContext";

export const DUTCH_ORIGIN = "nl";

export function countryOriginOptions(t) {
  return [
    { id: "se", name: t("country_origin.se") },
    { id: "no", name: t("country_origin.no") },
    { id: DUTCH_ORIGIN, name: t("country_origin.nl") },
  ];
}

/** Admins and sellers see and set the customer's country, on Swedish-portal customers only. */
export function canSetCountryOrigin(user, portalCountry) {
  return !!user && (user.role === "admin" || user.role === "seller") && portalCountry !== "no";
}

/** The "Nederländska kunder" / "Nederländska avtal" filters: admins and sellers on the Swedish portal. */
export function canFilterDutch(user) {
  return canSetCountryOrigin(user, isSwedishSite() ? "se" : "no");
}

/**
 * A Dutch customer: country_origin 'nl'. Only Swedish-portal customers can be one -
 * the Norwegian portal always wins.
 */
export function isDutchCustomer(customer) {
  return !!customer && customer.country_origin === DUTCH_ORIGIN && customer.country !== "no";
}

/** The country shown for a customer that has none stored yet: Sverige. */
export function countryOriginOf(customer) {
  return (customer && customer.country_origin) || "se";
}

/**
 * A number SecurCloud gave an agreement (SE/NO, or NL for a Dutch customer's agreement),
 * as opposed to "Kontant" or free text.
 */
export function isAgreementNumber(value) {
  return /^(SE|NO|NL)/.test(String(value || ""));
}
